<template>

  <div>

    <el-card class="card-base card-shadow--medium info bg-white black-text">
      <h2>Recent Jobs</h2>
      <el-alert
          v-if="recentJobsError"
          :title="recentJobsError"
          type="error"
          :closable="false"
          show-icon
          style="margin-bottom: 20px;">
        <template slot="default">
          <p>Unable to load recent jobs. Please check if Laravel Horizon is running.</p>
        </template>
      </el-alert>
      <el-table :data="recent_jobs.jobs" style="width: 100%; min-width:500px;" v-if="!recentJobsError && recent_jobs && recent_jobs.jobs && Array.isArray(recent_jobs.jobs) && recent_jobs.jobs.length > 0">
        <el-table-column prop="job">
          <template slot="header" slot-scope="scope">
            <span>Job</span>
          </template>
          <template slot-scope="scope">
            {{ getName(scope.row.name)}}
          </template>
        </el-table-column>
        <el-table-column prop="on">
          <template slot="header" slot-scope="scope">
            <span>On</span>
          </template>
          <template slot-scope="scope">
            {{ scope.row.queue }}
          </template>
        </el-table-column>
        <el-table-column prop="tags">
          <template slot="header" slot-scope="scope">
            <span>Tags</span>
          </template>
          <template slot-scope="scope">
            {{ scope.row.payload.tags }}
          </template>
        </el-table-column>
        <el-table-column prop="queued">
          <template slot="header" slot-scope="scope">
            <span>Queued At</span>
          </template>
          <template slot-scope="scope">
            {{ momentFormat(scope.row.payload.pushedAt) }}
          </template>
        </el-table-column>
        <el-table-column prop="runtime">
          <template slot="header" slot-scope="scope">
            <span>Runtime (sec.)</span>
          </template>
          <template slot-scope="scope">
            {{ executionTime(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="status">
          <template slot="header" slot-scope="scope">
            <span>Status</span>
          </template>
          <template slot-scope="scope">
            {{ scope.row.status }}
          </template>
        </el-table-column>
      </el-table>

    </el-card>
    <div class="pagin-wrp" v-if="!recentJobsError && recent_jobs && recent_jobs.total">
      <el-pagination
          :background="true"
          layout="prev, pager, next"
          :page-size="this.countNets"
          @current-change="chosePage"
          :total="recent_jobs.total"
      >
      </el-pagination>
    </div>
  </div>

</template>

<script>
import {mapGetters} from "vuex";
import moment from 'moment-timezone'

export default {
  name: "RecentJobs",
  data() {
    return {
      countNets: 50,
      chosenPage: 1,
      startingAt:-1,
      timer: ''
    }
  },
  computed: {
    ...mapGetters({
      recent_jobs: 'monitor/getRecentJobs',
      recentJobsError: 'monitor/getRecentJobsError',
    })
  },
  mounted () {
    this.updateRecentJobsList()
    this.timer = setInterval(this.updateRecentJobsList, 3000);
  },
  methods: {
    updateData() {
      var v = this;
      setTimeout(()=>{
        this.updateRecentJobsList();
        this.updateData();
      }, 3000)
    },
    cancelAutoUpdate () {
      clearInterval(this.timer);
    },

    momentFormat(date) {
      return moment.tz(parseInt(date*1000),this.$moment.tz.guess()).format('MM/DD/YYYY hh:mm')
    },
    getName(str) {
      let lastSlash = str.lastIndexOf('\\');
      return str.substring(lastSlash+1);
    },
    executionTime(data){
      let worktime = 0
      switch(data.status) {
        case 'completed':
          worktime = (data.completed_at?data.completed_at:data.reserved_at)- data.reserved_at;
          break;
        case 'failed':
          worktime = (data.failed_at ?data.failed_at: data.reserved_at) - data.reserved_at;
          break;
        default:
          worktime;
      }
      return worktime.toFixed(2)
    },

    chosePage (e) {
      this.chosenPage = e
      if(this.chosenPage==1){
        this.startingAt=-1;
      }else{
        this.startingAt =this.chosenPage*this.countNets;
      }
      this.updateRecentJobsList()
    },
    updateRecentJobsList(){
      let params = ''

      params = `starting_at=${this.startingAt}`
      if (this.countNets) {
        params = `${params}&limit=${this.countNets}`
      }

      this.$store.dispatch('monitor/getRecentJobs', params);
    }

  },
  beforeDestroy () {
    this.cancelAutoUpdate();
  }
}
</script>

<style >
.el-row {
  margin-bottom: 20px;

}
.el-row:last-child {
  margin-bottom: 0;
}

.el-col {
  border-radius: 5px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 5px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>